module.exports = __webpack_public_path__ + "8cbc2a37baeee9280b511df0f20f213d.png";